import { render } from "./Metal.vue?vue&type=template&id=21242401&scoped=true"
import script from "./Metal.vue?vue&type=script&lang=js"
export * from "./Metal.vue?vue&type=script&lang=js"

import "./Metal.vue?vue&type=style&index=0&id=21242401&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21242401"]])

export default __exports__